import React from 'react';

import IssuesIcon from '@atlaskit/icon/glyph/issues';

import { TreeNavigationButton } from '@qality/common-components/src/atoms/TreeNavigationButton';

import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider';
import { ALL_TEST_CASES } from '../TestCaseRepositoryPage.const';

export function TestCaseRepositoryAllTestCases(): JSX.Element {
  const { openAllTestCases, currentFolder } =
    useTestCaseRepositoryFoldersContext();

  return (
    <TreeNavigationButton
      onClick={openAllTestCases}
      isHighlighted={currentFolder === null}
      iconBefore={<IssuesIcon label={ALL_TEST_CASES} size='small' />}
    >
      {ALL_TEST_CASES}
    </TreeNavigationButton>
  );
}
